
export const toPayload = (action: any) => {
    return action['payload'];
};



